// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"47c8788b","496":"c0c53be3","850":"e5735e7a"}[chunkId] + ".chunk.js";
};